import React from "react";
import G2 from "@antv/g2";
import DataSet from "@antv/data-set";

class RingChart extends React.Component {
    dv = undefined;
    chart = undefined;
    componentDidMount() {
    	const { DataView } = DataSet;
    	const { chart_id, height, labelKey, valueKey, forceFit, padding } = this.props;
    	this.dv = new DataView();
    	this.chart = new G2.Chart({
    		container: chart_id, 
    		forceFit,
    		height,
    		padding
    	});
    	this.chart.coord("theta", {
    		radius: 0.75,
    		innerRadius: 0.6
    	});
    	this.chart.legend(false);
    	this.chart.tooltip({
    		showTitle: false,
    		itemTpl: "<li><span style=\"background-color:{color};\" class=\"g2-tooltip-marker\"></span>{name}: {value}</li>"
    	});
    	this.chart.intervalStack()
    		.position("percent")
    		.color("item")
    		.tooltip(`${labelKey}*${valueKey}`, (item, percent) => {
    			percent = (percent * 100).toFixed(2) + "%";
    			return {
    				name: item,
    				value: percent
    			};
    		})
    		.style({
    			lineWidth: 1,
    			stroke: "#fff"
    		});
    	this.updateValues(this.props, true);
    }
    componentWillReceiveProps(props){
    	this.updateValues(props, true);
    }
    updateValues(props, render = true){
    	const { chart_id, data, labelKey, valueKey } = props;
    	this.dv.source(data).transform({
    		type: "percent",
    		field: valueKey,
    		dimension: labelKey,
    		as: "percent"
    	});
    	this.chart.source(this.dv, {
    		percent: {
    			formatter: val => {
    				val = (val * 100).toFixed(2) + "%";
    				return val;
    			}
    		},
    	});
    	if(render){
    		this.chart.render();
    	}
    }
    render(){
    	return <div id={this.props.chart_id}></div>;
    }
}

RingChart.defaultProps = {
	chart_id:"ringchart",
	data: [],
	height: 300,
	labelKey:"item",
	valueKey:"percent",
	forceFit: true,
	padding:[0,0,0,0]
};

export default RingChart;


// WEBPACK FOOTER //
// ./src/components/chart/RingChart.js